document.addEventListener('DOMContentLoaded', function() {
  function removeAriaSelected() {
    document.querySelectorAll('.gallery-cell[aria-selected], .logo-list__item[aria-selected]').forEach(function(el) {
      el.removeAttribute('aria-selected');
    });
  }
  
  removeAriaSelected();
  
  const observer = new MutationObserver(removeAriaSelected);
  document.querySelectorAll('.js-homepage-slideshow, [data-logo-slider]').forEach(function(slider) {
    if (slider) {
      observer.observe(slider, { attributes: true, subtree: true, attributeFilter: ['aria-selected'] });
    }
  });
});